import React, {FC, ReactElement, useState} from "react";
import {SidebarWidthMenu} from "../../../helpers/context/SidebarWidthMenu";
import Sidebar from "../Sidebar/Sidebar";
import styles from "./Layout.module.scss";

type Props = {children?: ReactElement}

const Layout: FC<Props> = ({children}): JSX.Element => {
    const [sidebarWidth, setSidebarWidth] = useState(0);
    const [toggleMenu, setToggleMenu] = useState(false);
    return(
        <div className="layout-wrapper">
            <SidebarWidthMenu.Provider value={{sidebarWidth, setSidebarWidth, toggleMenu, setToggleMenu}}>
                <Sidebar/>
                <div className={styles.mainContent} style={{marginLeft: sidebarWidth}}>
                    {children ? React.cloneElement(children) : ''}
                </div>
            </SidebarWidthMenu.Provider>
        </div>
    )
}

export default Layout;